import moment from 'moment'

export function formatTimerSeconds(totalSeconds = 0) {
  const safeSeconds = Math.max(0, Math.floor(totalSeconds))
  const hours = String(Math.floor(safeSeconds / 3600)).padStart(2, '0')
  const minutes = String(Math.floor((safeSeconds % 3600) / 60)).padStart(2, '0')
  const seconds = String(safeSeconds % 60).padStart(2, '0')
  return `${hours}:${minutes}:${seconds}`
}

export function createDailyLogPayload(timer) {
  return {
    activityTime: {
      startOn: moment(timer.startedAt).format('YYYY-MM-DDTHH:mm:ss'),
      endOn: moment(timer.endedAt).format('YYYY-MM-DDTHH:mm:ss'),
      focusTimeSec: timer.dailyLogType === 'STUDY' ? timer.focusTimeSec : null,
      isFocusRateExcluded: timer.dailyLogType !== 'STUDY',
    },
    dailyLogType: timer.dailyLogType,
    contents: timer.contents.trim(),
  }
}
